'use client'

import { cn } from '@/shared/lib/utils'

interface QuizProgressPipsProps {
  total: number
  currentIndex: number
  /** Índices já respondidos — o aluno vê o que falta sem abrir cada questão. */
  answeredIndexes: number[]
  onSelect: (index: number) => void
}

export function QuizProgressPips({
  total,
  currentIndex,
  answeredIndexes,
  onSelect
}: QuizProgressPipsProps) {
  return (
    <div className="flex flex-wrap items-center gap-2" role="tablist">
      {Array.from({ length: total }, (_, index) => {
        const answered = answeredIndexes.includes(index)
        const current = index === currentIndex

        return (
          <button
            key={index}
            type="button"
            role="tab"
            aria-selected={current}
            aria-label={`Pergunta ${index + 1}${answered ? ', respondida' : ''}`}
            onClick={() => onSelect(index)}
            className={cn(
              'size-8 rounded-lg font-hl text-sm font-black transition-all duration-100',
              current
                ? 'translate-y-px bg-jacaranda text-white shadow-[inset_0_2px_5px_rgba(0,0,0,0.30)]'
                : answered
                  ? 'bg-white/80 text-jacaranda shadow-[0_3px_0_-1px_#78229f]'
                  : 'bg-white/40 text-[#7F7FAD] shadow-[0_3px_0_-1px_rgba(120,34,159,0.35)]'
            )}
          >
            {index + 1}
          </button>
        )
      })}
    </div>
  )
}
